import {Component} from '@angular/core';

/*##################################################################################* 
 * COMPOSANT SPRO : spro-loading
 * 
 * DESCRIPTION : Permet d'afficher une animation de chargement
 * 
 ##################################################################################*/

@Component({
  selector: 'spro-loading',
  styleUrls: ['./spro-loading.component.scss'],
  template:
  `
<div  class="sk-folding-cube">
  <div class="sk-cube1 sk-cube"></div>
  <div class="sk-cube2 sk-cube"></div>
  <div class="sk-cube4 sk-cube"></div>
  <div class="sk-cube3 sk-cube"></div>
</div>
`,
})
export class spro_cls_loading {}


// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/utils/spro-loading/spro-loading.component.ts